import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AssignedSalesRep } from '../models/entities/assigned-sales-rep';
import { DemoSchedulerDialogComponent, DemoSchedulerDialogInput } from '../components/app-layout/shared/demo-scheduler-dialog/demo-scheduler-dialog.component';
import { MatDialogSizes } from '../enums/mat-dialog-sizes.enum';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Injectable({
    providedIn: 'root',
})
export class DemoSchedulerService
{
    readonly assignedSalesRep$: BehaviorSubject<AssignedSalesRep> = new BehaviorSubject(new AssignedSalesRep({}));
    readonly loading$: BehaviorSubject<boolean> = new BehaviorSubject(true);

    constructor(
            private _dialog: MatDialog,
    ) {
    }

    scheduleDemo() {
        const data: DemoSchedulerDialogInput = {
            assignedSalesRep: this.assignedSalesRep$.getValue(),
        };

        this._dialog.open(DemoSchedulerDialogComponent, {
            panelClass: 'demo-scheduler-dialog',
            width: MatDialogSizes.LG,
            data,
        });
    }

    assignSalesRepForDemo(rep: AssignedSalesRep) {
        this.assignedSalesRep$.next(rep);
        this.loading$.next(false);
    }
}
